import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withHashLocation, withInMemoryScrolling, withRouterConfig, withViewTransitions } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { provideServiceWorker } from '@angular/service-worker';
import Aura from '@primeuix/themes/aura';
import { MessageService, ConfirmationService } from 'primeng/api';
import { routes } from './app.routes';
import { jwtInterceptor } from './core/interceptors/jwt.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withRouterConfig({
                onSameUrlNavigation: 'ignore'
            }),
            withInMemoryScrolling({
                scrollPositionRestoration: 'top',
                anchorScrolling: 'enabled'
            }),
            withEnabledBlockingInitialNavigation(),
            // withViewTransitions(),
            withHashLocation()
        ),
        provideHttpClient(withInterceptors([jwtInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    // Usa la clase CSS .dark para modo oscuro (no media query)
                    darkModeSelector: '.dark',
                    // Integración con Tailwind v4 / tailwindcss-primeui
                    cssLayer: {
                        name: 'primeng',
                        order: 'tailwind-base, primeng, tailwind-utilities'
                    }
                }
            },
            // Desactiva la animación de apertura/cierre de todos los overlays PrimeNG
            // (selects, dropdowns, menus, etc.) para evitar parpadeo/re-activación.
            overlayOptions: { motionOptions: { disabled: true } },
            ripple: true
        }),
        // Servicios globales PrimeNG disponibles en toda la app
        MessageService,
        ConfirmationService,
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:3000'
        })
    ]
};
